import { useSelector } from "react-redux";
import "./index.scss"

const Note = (props) => {
  const dataMatchAggregate = useSelector(state => state.dashboardDetailReducer?.dataMatchAggregate);
  let { label, size, alert_type, trigger, dynamic_note, variable_show, threshold_value,custom_styles } = props
  if(eval(dynamic_note)){
    label = label.replace(variable_show[0],eval(variable_show[0]));
    let trigger_type = dataMatchAggregate.split("%");
    if(parseInt(trigger_type[0]) <= parseInt(threshold_value)){
      alert_type = "danger";
    } else alert_type = alert_type;
  }
  return (
    <div className={size}>
    <div className={`note_container_${alert_type} ${custom_styles}`}>
      {trigger !== null && <p className={`${alert_type}`}>{trigger}</p>}
      {label}
    </div>
  </div>
  )
}

export default Note